import { ApplicationConfig } from '@angular/core';
import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import { healthMetricInterceptor } from '@lentau/analytics/health-metrics/interceptors/health-metric.interceptor';
import { openTelemetryInterceptor } from '@lentau/core/open-telemetry/application/interceptors/open-telemetry.interceptor';
import { authErrorInterceptor } from '@lentau/api/application/interceptors/auth-error.interceptor';
import { handle500Interceptor } from '@lentau/api/application/interceptors/500.interceptor';
import { handle302Interceptor } from '@lentau/api/application/interceptors/302.interceptor';
import { logoutInterceptor } from '@lentau/api/application/interceptors/logout.interceptor';
import { requestErrorAnalyticInterceptor } from '@lentau/api/application/interceptors/request-error-analytic.interceptor';
import { gtmInterceptor } from '@lentau/api/application/interceptors/gtm.interceptor';
import { handleTokenWaitInterceptor } from '@lentau/api/application/interceptors/token-wait.interceptor';

export const multiBrandBrowserConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(
      withXhr(),
      withInterceptors([
        logoutInterceptor,
        authErrorInterceptor,
        handle500Interceptor,
        handle302Interceptor,
        openTelemetryInterceptor,
        healthMetricInterceptor,
        requestErrorAnalyticInterceptor,
        gtmInterceptor,
        handleTokenWaitInterceptor,
      ])
    ),
  ],
};
